// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Box, BoxProps, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface Props extends Pick<BoxProps, 'sx'> {
  /**
   * The label text displayed above the value.
   */
  label: string;

  /**
   * Optional adornment displayed next to the label (e.g., info icon for ARR).
   */
  labelAdornment?: ReactNode;

  /**
   * The value content to display below the label.
   */
  children: ReactNode;
}

/**
 * Renders a consistent label+value field for the project details header.
 * Provides uniform spacing and alignment across all project detail fields.
 */
export function ProjectDetailField(props: Props) {
  return (
    <Box sx={props.sx}>
      <Stack direction="row" alignItems="center" marginBottom={0.5}>
        <Typography variant="subtitle2">{props.label}</Typography>
        {props.labelAdornment}
      </Stack>
      {props.children}
    </Box>
  );
}
